import React from 'react';

import { Typography, Box } from '@mui/material';
import "./Title.css";

export const Title = (props) => {
  const { channel, Username } = props;
  return (
    <Box className="Title">
      <Typography className='TilteText'>{Username} {`<>`} {channel}</Typography>
    </Box>
  );
};